'use client'

import Wallet from '@/utils/wallet'
import axios from 'axios'
import useSWR, { useSWRConfig } from 'swr'
import { STORAGE_TAPROOT_ADDRESS, FIREBASE_CF_SAVE_TOKEN_API_URL } from '@/utils/constants'
import jwtAndEncrypt from '@/utils/jwt-and-encrypt'

import SafeLocalStorage from '@/utils/safe-local-storage'
import { initializeApp } from 'firebase/app'
import { getMessaging, getToken } from 'firebase/messaging'
const firebaseConfig = {
	apiKey: 'AIzaSyAdam32f-WqoF5ac8JRHhQLYfuiytQkCjU',
	authDomain: 'ordinals-wallet-8f5c7.firebaseapp.com',
	projectId: 'ordinals-wallet-8f5c7',
	storageBucket: 'ordinals-wallet-8f5c7.appspot.com',
	messagingSenderId: '58956925567',
	appId: '1:58956925567:web:95f794f262900148c10d4a',
	measurementId: 'G-XE6HRW50QJ',
	// The value of `databaseURL` depends on the location of the database
	databaseURL: 'https://ordinals-wallet-8f5c7-default-rtdb.firebaseio.com/'
}

const KEY = '/is-logged-in'

const fetcher = () => {
	return Wallet.isSet()
}

const useLoggedIn = () => {
	const { data: loggedIn } = useSWR(KEY, fetcher)
	return loggedIn
}

const useLogout = () => {
	const { mutate } = useSWRConfig()
	const logout = () => {
		Wallet.delete()
		// Publish the signed-out state immediately. Revalidating after deleting
		// storage left one render where pages still believed a wallet existed.
		void mutate(KEY, false, { revalidate: false })
	}

	return logout
}

const useSignIn = () => {
	const { mutate } = useSWRConfig()
	const signIn = () => {
		Wallet.register()
		mutate(KEY)
	}

	return signIn
}

const saveFcmToken = () => {
	const isInStandaloneMode = 'standalone' in window.navigator && window.navigator?.standalone

	if (typeof Notification !== 'undefined' && isInStandaloneMode) {
		Notification.requestPermission()
			.then((permission) => {
				const app = initializeApp(firebaseConfig)
				if (permission === 'granted') {
					const messaging = getMessaging(app)
					getToken(messaging, {
						vapidKey:
							'BGLxBQiv0VBYMQ7r1WDO9jymplH6Tk1vMI9yc6V_f0gIU_xIjDdHEozGoFmLGb_udd24F646_j0CpS3-FpX8y6w'
					})
						.then((currentToken) => {
							if (currentToken) {
								var walletAddress = SafeLocalStorage.getItem(STORAGE_TAPROOT_ADDRESS)
								var body = jwtAndEncrypt(walletAddress, currentToken)
								axios
									.post(`${FIREBASE_CF_SAVE_TOKEN_API_URL}`, body)
									.then((_res) => {
									})
									.catch((e) => {
										console.log(e)
									})
							}
						})
						.catch((err) => {
							console.log('An error occurred while retrieving token. ', err)
						})
				}
			})
			.catch((err) => {
				console.log(err)
			})
	}

	return null
}

export { useLoggedIn as default, useSignIn, useLogout, saveFcmToken }
